import ModuleCtrl from '../_shared/core/ModuleCtrl';
// import {modules} from './modules/_index';
import {$} from '../_shared/core/DomU';
import Router from '../_shared/core/Router';
import Ticker from '../_shared/core/Ticker';
import WinU from '../_shared/core/WinU';
import ModalCtrl from '../_shared/core/ModalCtrl';
import u_domReady from '../_shared/utils/u_domReady';

const DEV = process.env.NODE_ENV !== 'production';

export default class rMain {
  constructor() {
    // ModuleCtrl.setup(modules);

    $('html')
      .addClass('html_domReady')
      .removeClass('html_initial');

    //guide
    // if (DEV) {
    //   const Guide = require('../_shared/core/Guide').default;
    //   new Guide();
    // }

    return Promise.resolve()
      .then(Router.setup.bind(Router))
      .then(Ticker.setup.bind(Ticker))
      .then(WinU.setup.bind(WinU))
      //.then(ModuleCtrl.init.bind(ModuleCtrl))
      .then(ModalCtrl.setup.bind(ModalCtrl))
      .then(u_domReady)
      .then(ModuleCtrl.start.bind(ModuleCtrl))
  }
}
